import {
  LOAD_BEHAVIORDRIVING,
  LOAD_BEHAVIORDRIVING_PREVIEW,
  LOAD_VEHICLE_BEHAVIORDRIVING,
} from './actions'

const initialState = {
  vehicleLists: [],
  behaviordrivingLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_BEHAVIORDRIVING.REQUEST:
    case LOAD_BEHAVIORDRIVING_PREVIEW.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        behaviordrivingLoading: loading,
      }
    case LOAD_BEHAVIORDRIVING.SUCCESS:
    case LOAD_BEHAVIORDRIVING_PREVIEW.SUCCESS:
      return {
        ...state,
        behaviordrivingLoading: false,
      }
    case LOAD_VEHICLE_BEHAVIORDRIVING.REQUEST:
      const { loading_vehicle } = action.payload
      return {
        ...state,
        behaviordrivingLoading: loading_vehicle,
      }
    case LOAD_VEHICLE_BEHAVIORDRIVING.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        behaviordrivingLoading: false,
      }
    default:
      return state
  }
}
